<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit">관리자 로그인 조회</h2>
        <section class="admin-contents">
          <div class="card-body">
            <table class="card-table">
              <caption>관리자 로그인 조회</caption>
              <colgroup>
                <col style="width:10%">
                <col style="width:40%">
                <col style="width:40%">
                <col style="width:10%">
              </colgroup>
              <tr>
                <th>no</th>
                <th>ID</th>
                <th>접속 일시</th>
                <th>IP</th>
              </tr>
              <tr v-for="(item, index) in this.getAdminlogInfo.content" v-bind:key="index">
                <td colspan="row">{{item.id}}</td>
                <td>{{item.loginId}}</td>
                <td>{{item.modifiedDate}}</td>
                <td>{{item.ip}}</td>
              </tr>
            </table>
          </div>
          <div class="card-footer">
            <paginate v-model="currentPage"
            :page-count="getTotalPage"
            :page-range="5"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'이전'"
            :next-text="'다음'"
            :container-class="'pagination'"
            :page-class="'page-item'">
            </paginate>
          </div>
        </section>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>

<style lang="css">
@import '../css/bootstrap.min.css';
</style>

<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminInquiry',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside
  },
  data () {
    return {
      currentPage: 1
    }
  },
  created () {
    this.setInit()
  },
  methods: {
    ...mapActions({
      setInit: 'apiAdminLoginlog'
    }),
    clickCallback (pageNum) {
      this.$store.dispatch('apiAdminLoginlog', pageNum)
    }
  },
  computed: {
    ...mapGetters(['getAdminlogInfo']),
    ...mapGetters(['getTotalPage'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminInquiry.vue